import { styled } from '@mui/system';
import { alpha } from '@mui/system/colorManipulator';

export const DropzoneCnt = styled('section', {
  shouldForwardProp: prop => !['isDragging', 'hasError', 'isDisabled'].includes(prop)
})(({ theme, isDragging, hasError, isDisabled }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: theme.spacing(1),
  minHeight: 250,
  border: `1px solid ${theme.palette.grey[400]}`,
  outline: `2px dashed ${theme.palette.grey[400]}`,
  outlineOffset: -10,
  borderRadius: 4,
  backgroundColor: theme.palette.grey[200],
  fontWeight: 500,
  ...(isDisabled && {
    color: theme.palette.grey[400]
  }),
  ...(isDragging && hasError && {
    backgroundColor: theme.palette.error.main,
    borderColor: 'inherit',
    outlineColor: 'inherit'
  }),
  ...(isDragging && !hasError && {
    backgroundColor: alpha(theme.palette.secondary.main, 0.5),
    borderColor: 'inherit',
    outlineColor: 'inherit'
  })
}));
